/**
 * TourAudioControls — the sound-effects and music toggle pair shared by the
 * How It Works hub and every chapter's TourShell chrome. Toggling is also an
 * unlock gesture, so enabling music here starts it immediately.
 */
import { MusicNote, MusicOff, VolumeOff, VolumeUp } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import type { TourAudio } from './useTourAudio';

interface TourAudioControlsProps {
  audio: TourAudio;
}

export const TourAudioControls = ({ audio }: TourAudioControlsProps) => {
  const theme = useTheme();
  return (
    <>
      <Tooltip title={audio.sfxOn ? 'Sound effects on' : 'Sound effects off'}>
        <IconButton
          onClick={() => { audio.unlock(); audio.toggleSfx(); }}
          sx={{ color: alpha(theme.palette.common.white, audio.sfxOn ? 0.9 : 0.35) }}
        >
          {audio.sfxOn ? <VolumeUp fontSize="small" /> : <VolumeOff fontSize="small" />}
        </IconButton>
      </Tooltip>
      <Tooltip title={audio.musicOn ? 'Music on' : 'Music off'}>
        <IconButton
          onClick={() => { audio.unlock(); audio.toggleMusic(); }}
          sx={{ color: alpha(theme.palette.common.white, audio.musicOn ? 0.9 : 0.35) }}
        >
          {audio.musicOn ? <MusicNote fontSize="small" /> : <MusicOff fontSize="small" />}
        </IconButton>
      </Tooltip>
    </>
  );
};
